module.exports = __webpack_public_path__ + "img/photo.5f5985e1.svg";